var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._g({ staticClass: "swatches-static" }, _vm.$listeners),
    _vm._l(_vm.variants, function(variant, index) {
      return _c(
        "button",
        {
          key: "swatch_" + variant.id,
          staticClass: "swatches-static__swatch",
          class: {
            "swatches-static__swatch--active": _vm.getActiveValue(variant)
          },
          attrs: {
            "aria-controls": _vm.ariaControls,
            "aria-label": variant[_vm.optionKey],
            title: variant[_vm.optionKey],
            tabindex: "0",
            disabled: _vm.getDisabledValue(variant)
          },
          on: {
            keyup: function($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter") &&
                _vm._k($event.keyCode, "space", 32, $event.key, [
                  " ",
                  "Spacebar"
                ])
              ) {
                return null
              }
              $event.stopPropagation()
              return _vm.$emit("input", variant)
            },
            click: function($event) {
              $event.stopPropagation()
              return _vm.$emit("input", variant)
            }
          }
        },
        [
          !_vm.showDefault[index] && variant.swatch_image
            ? _c("img", {
                attrs: {
                  src: variant.swatch_image,
                  alt: variant[_vm.optionKey]
                },
                on: {
                  error: function($event) {
                    return _vm.$set(_vm.showDefault, index, true)
                  }
                }
              })
            : !_vm.showDefault[index]
            ? _c("img", {
                attrs: {
                  src: _vm.fileUrl(
                    "swatch_" + _vm.normalize(variant[_vm.optionKey]) + ".png"
                  ),
                  alt: variant[_vm.optionKey]
                },
                on: {
                  error: function($event) {
                    return _vm.$set(_vm.showDefault, index, true)
                  }
                }
              })
            : _c("img", {
                attrs: {
                  src: _vm.fileUrl("swatch_default_color.png"),
                  alt: variant[_vm.optionKey]
                }
              })
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }